module.exports = __webpack_public_path__ + "img/home_7.09d02659.png";